import type { DistanceUnit } from "../types";

export const formatCoordinate = (value: number) => value.toFixed(5);

export const formatDistance = (value: number, unit: DistanceUnit) =>
  `${value.toFixed(2)} ${unit}`;

export const formatBearing = (value: number) => `${value.toFixed(1)}°`;

export const formatDateTime = (iso: string) =>
  new Date(iso).toLocaleString();
